<template>
  <div
    class="grid grid-cols-2 gap-2 pb-3 border-b border-gray-200 odd:bg-gray-200/50"
  >
    <CCardCoin without-link :card="data" :pair="data?.pair" />
    <CInfoData :title="$t('bot_single.profit')">
      <span>{{ formatMoneyDecimal(Number(data?.profit) ?? 0, 2) }}</span>
    </CInfoData>
    <CInfoData :title="$t('profit_ustd')">
      <span class="text-dark-300">
        {{ formatMoneyDecimal(Number(data?.profit_abs) ?? 0, 4).split(".")?.[0]
        }}<span class="text-gray-380" v-if="data?.profit_abs"
          >.{{
            formatMoneyDecimal(Number(data?.profit_abs) ?? 0, 4).split(".")?.[1]
          }}
        </span>
      </span>
    </CInfoData>
    <CInfoData :title="$t('count')">
      {{ data?.count }}
    </CInfoData>
  </div>
</template>

<script setup lang="ts">
import CInfoData from "@/components/Common/CInfoData.vue";
import CCardCoin from "@/modules/Bots/components/CCardCoin.vue";
import { formatMoneyDecimal } from "@/utils";

interface Props {
  data: {
    id: number;
    bot: number;
    profit_ratio: string;
    profit_pct: string;
    profit_abs: string;
    count: number;
    pair: string;
    profit: string;
  };
}
defineProps<Props>();
</script>

<style scoped></style>
